<!-- 渠道参数配置 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
		<!-- 标题 -->
		<div class="page-title" style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">渠道书库-下载参数管理</div>
		
		<!-- <div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">状态</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择状态"
					@change="handleChangeA"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">开启</a-select-option>
					<a-select-option value="0">关闭</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="addButton" type="primary">添加企业微信</a-button>
		</div> -->
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="cursor: default;" 
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<!-- ID -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<!-- 渠道名称 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						{{item.name}}
					</div>
				</div>
				
				<!-- 免费Cookie -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					<div v-if="item.cookie && item.cookie.length > 60">
						<a-popover placement="top">
							<template slot="content">
							  <p style="width: 450px;word-break: break-all;">{{item.cookie}}</p>
							</template>
							<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
								{{item.cookie}}
							</div>
						</a-popover>
					</div>
					<div v-else>{{item.cookie}}</div>
				</div>
				<!-- 会员Cookie -->
				<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
					<div v-if="item.vip_cookie && item.vip_cookie.length > 60">
						<a-popover placement="top">
							<template slot="content">
							  <p style="width: 450px;word-break: break-all;">{{item.vip_cookie}}</p>
							</template>
							<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
								{{item.vip_cookie}}
							</div>
						</a-popover>
					</div>
					<div v-else>{{item.vip_cookie}}</div>
				</div>
				<!-- UA -->
				<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
					<div v-if="item.ua && item.ua.length > 60">
						<a-popover placement="top">
							<template slot="content">
							  <p style="width: 450px;word-break: break-all;">{{item.ua}}</p>
							</template>
							<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
								{{item.ua}}
							</div>
						</a-popover>
					</div>
					<div v-else>{{item.ua}}</div>
				</div>
				<!-- Token -->
				<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
					{{item.token}}
				</div>
				<!-- 状态 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
					{{item.status == 1?'是':'否'}}
				</div>
				<!-- 操作 -->
				<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[7].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
				
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		<div :style="{'width': body_width + 'px',}" style="text-align: center;margin-top: 30px;position: sticky;left: 30px;z-index: 5;">
			<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange"  />
		</div>
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="700px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">渠道<span class="required-hint">*</span></div>
				
				<div style="width: 450px;">{{x_name}}</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">免费cookie</div>
					
				<a-textarea
				      v-model="x_cookie"
				      placeholder="请输入 "
				      :auto-size="{ minRows: 6, maxRows: 15 }" 
					  style="width: 500px;"
				    />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">会员cookie</div>
					
				<a-textarea
				      v-model="x_vip_cookie"
				      placeholder="请输入 "
				      :auto-size="{ minRows: 6, maxRows: 15 }" 
					  style="width: 500px;"
				    />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">ua</div>
					
				<a-textarea
				      v-model="x_ua"
				      placeholder="请输入 "
				      :auto-size="{ minRows: 5, maxRows: 12 }" 
					  style="width: 500px;"
				    />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">token</div>
					
				<a-textarea
				      v-model="x_token"
				      placeholder="请输入 "
				      :auto-size="{ minRows: 3, maxRows: 8 }" 
					  style="width: 500px;"
				    />
			</div>
			
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { libDownList, libDownEdit } from '@/request/api'
export default {
	name: 'libraryDownParams_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"渠道名称", width:120, type:"name", },
				{title:"免费Cookie", width:360, type:"cookie", },
				{title:"会员Cookie", width:360, type:"vip_cookie", },
				{title:"UA", width:360, type:"ua", },
				{title:"Token", width:200, type:"token", },
				{title:"状态", width:100, type:"status", },
				{title:"操作", width:100, type:"cz", },
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			
			search_button_loading: false,
			r_search:"",
			r_page: 1,
			table_total: 0,
			r_status: undefined, // 状态
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			// 新增/编辑参数
			x_id: '', // id
			x_name: "", // 渠道名字
			x_cookie: "", // 免费cookie
			x_vip_cookie: "", // 会员cookie
			x_ua: "", // ua
			x_token: "", // token
			
		}
	},
	mounted(){
		let that = this
		
		that.body_width = document.body.clientWidth - 100 // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		that.searchButton()
		
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		handleChangeA(e){
			console.log(e);
			this.r_status = e
		},
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			libDownList({
				page: that.r_page,
				status: that.r_status
				}).then(res=>{
				console.log("列表结果",res.data.data)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					
					let data = res.data.data.data
					data.forEach((res,index)=>{
						res.status_checked = false
						res.status_loading = false // 变更状态的加载中状态
						if(res.status == 1){ // 1=开启 0=关闭
							res.status_checked = true
						}
					})
					that.tableShowData = data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editTable(index,item){
			let that = this
			console.log("item",item);
			that.drawer_title = "编辑"
			that.x_id = item.id
			that.x_name = item.name // 渠道
			that.x_cookie = item.cookie
			that.x_token = item.token 
			that.x_ua = item.ua 
			that.x_vip_cookie = item.vip_cookie 
			
			
			that.visible = true
		},
		
		// 侧边栏的新增/编辑
		addRequest(){
			let that = this
			console.log("contentTableData",that.contentTableData);
			if(!that.x_name){ // 名称
				// that.add_form_hint = "请填写 名称 ！！！"
				that.$message.warning('请填写 名称 ！！！');
			}
			
			else if(!that.x_token){ // token
				that.$message.warning('请填写 token ！！！');
			}
			
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					id: that.x_id,
					cookie: that.x_cookie, 
					token: that.x_token, 
					ua: that.x_ua, 
					vip_cookie: that.x_vip_cookie, 
				}
				
				if(that.drawer_title == "新增"){
					// jumpQwAdd(r_data).then(res=>{
					// 	console.log("新增",res)
					// 	that.add_button_loading = false
						
					// 	if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					// 		that.onCloseDrawer()
					// 		that.$message.success('新增成功');
					// 		that.searchButton()
					// 	}
					// 	else {
					// 		if(res.data.code == 401){ // 未登录
					// 			localStorage.removeItem("access_token");
					// 			that.$router.replace({name: 'login',params: {type:'not_log'}})
					// 			return
					// 		}
					// 		that.$message.error(res.data.msg || "新增失败");
					// 	}
					// })
					// .catch(err=>{
					// 	console.log(err)
					// 	that.$message.error("新增失败，可能是网络出现问题");
					// })
				}
				else if(that.drawer_title == "编辑"){
					libDownEdit(r_data).then(res=>{
						console.log("编辑",res)
						that.add_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('编辑成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("编辑失败，可能是网络出现问题");
					})
				}
				
			}
			
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			this.x_id = ""
			this.x_name = "" // 名称
			this.x_cookie = "" 
			this.x_token = ""  
			this.x_ua = ""  
			this.x_vip_cookie = ""  
			
			
			this.add_form_hint = ""
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		
		
	}
}
</script>

<style scoped>
.form-cell-box {
	margin-bottom: 20px;
}

</style>